import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://bpmn-dev-api.strimco.fitness/api/v2',
  OAuth2ClientId: '1067959382028-8i2cuv8s2uen09d3g4hc6ma4voejkavc.apps.googleusercontent.com',
  sharePublicBaseUrl: '',
};
